import React from 'react';

export const Logo = ({ size = "md" }) => {
  const sizes = {
    sm: "h-12",
    md: "h-16",
    lg: "h-20",
  };
  const h = sizes[size] || sizes.md;

  return (
    <div className="flex items-center">
      <img
        src="/logo-ler.png"
        alt="Location Benne Chantier"
        className={`${h} w-auto object-contain`}
        data-testid="logo-image"
      />
    </div>
  );
};

export default Logo;
